<script>
/* jshint esversion: 6 */
import {watch, computed, inject } from 'vue'; 
import './../func.common'; 
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default{
    name: 'DoubleInputVfor',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'id': { type: String, default: ''}, 
        'schemaId': {type: Number, default: 0}, 
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'disabled': {type: Boolean},
		'hinted': {type:String},
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
                'vTxext': props.schema.validatorText
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep: true});
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .doubleInputVFor(
        :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    ) 
        .row.justify-content-between
            .col-12
                label {{schema.label}}
            .col-12
                .form-group.row.gx-3-align-items-left(
                    :style="disabled === true ? 'cursor:not-allowed; opacity: 0.5': ''"
                ) 
                    template(v-for="item, index in model[schema.model]")
                        .col-12.fieldInputVFor
                            .row
                                .col-12
                                    label {{index+1}}. {{schema.labelElement}}
                            .row.justify-content-between 
                                .col-6
                                    .col-12.inputField 
                                        .fullField.fieldInput
                                            input.form-control(
                                                type="text" 
                                                :name="model[schema.model]" 
                                                :value="item[0]" 
                                                v-model="item[0]" 
                                                maxlength="255"
                                                :placeholder="`${index+1}. ${schema.placeholder1}`"
                                                :style="disabled === true ? 'pointer-events:none': ''"
                                            )                                            
                                .col-6
                                    .col-12.inputField 
                                        .fullField.fieldInput
                                            input.form-control(
                                                :type="schema.inputType" 
                                                :name="model[schema.model]" 
                                                :value="item[1]" 
                                                v-model="item[1]" 
                                                maxlength="255"
                                                :placeholder="`${index+1}. ${schema.placeholder2}`"
                                                :style="disabled === true ? 'pointer-events:none': ''"
                                            )                                    
                .row.fieldInput.col-12
                    .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
                    .vueFormSmall.labelred(v-if="schema.errorShow === true")
                        font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                        | &nbsp;{{ schema.errorText[0] }}
</template>